import { Plural, Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconCalendar from '@/icons/Calendar.svg';

export const ArticleManualRepairDueDatesUpdatedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_manual_repair_due_days_updated'>;

  displayArticleName: boolean;
}) => {
  const creatorName = activity?.creator.name;
  const previousValue = activity?.data.before;
  const newValue = activity?.data.after;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="neutral"
      icon={<IconCalendar />}
      message={
        <BaseActivityText>
          {newValue !== null && previousValue !== null && (
            <Trans id="activities.article_manual_repair_due_days_updated.message">
              <strong>{creatorName}</strong> changed the repair duration from{' '}
              <strong>
                <Plural value={previousValue} one="# working day" other="# working days" />
              </strong>{' '}
              to{' '}
              <strong>
                <Plural value={newValue} one="# working day" other="# working days" />
              </strong>{' '}
              for the item{' '}
            </Trans>
          )}
          {newValue === null && previousValue !== null && (
            <Trans id="activities.article_manual_repair_due_days_updated.messageAfterNull">
              <strong>{creatorName}</strong> reset the repair duration from{' '}
              <strong>
                <Plural value={previousValue} one="# working day" other="# working days" />
              </strong>{' '}
              to default for the item{' '}
            </Trans>
          )}

          {newValue !== null && previousValue == null && (
            <Trans id="activities.article_manual_repair_due_days_updated.messageBeforeNull">
              <strong>{creatorName}</strong> changed the repair duration from default to{' '}
              <strong>
                <Plural value={newValue} one="# working day" other="# working days" />
              </strong>{' '}
              for the item{' '}
            </Trans>
          )}

          <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
        </BaseActivityText>
      }
    ></BaseActivity>
  );
};
